import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import api from '../services/api';
import NoticiaImage from '../components/NoticiaImage';
import { convocatoriaCerrada, formatarFechaLocal } from '../utils/fileUtils';
import { FaStar, FaFilePdf } from 'react-icons/fa';
import './ConvocatoriaDetalle.css';

// PDF servido por el backend (no depende de nginx)
const PDF_SECRETARIA_URL = '/api/pdf/terminos';

const TEXTO_INVITACION_SECRETARIA = 'La Diócesis de Ipiales invita a profesionales interesados en servir a la comunidad y contribuir a nuestra misión institucional a participar en el proceso de selección para el cargo de: Secretaria General.';

const ConvocatoriaDetalle = () => {
  const { id } = useParams();

  const { data: convocatoria, isLoading } = useQuery({
    queryKey: ['convocatoria', id],
    queryFn: async () => {
      const response = await api.get(`/convocatorias/${id}`);
      return response.data;
    },
    retry: false
  });

  if (isLoading) {
    return <div className="loading">Cargando convocatoria...</div>;
  }

  if (!convocatoria) {
    return (
      <div className="not-found">
        <h2>Convocatoria no encontrada</h2>
        <Link to="/convocatorias" className="btn">Volver a convocatorias</Link>
      </div>
    );
  }

  // Página simplificada para Secretaria General: solo texto breve + enlace al PDF (sin descripción completa)
  const esSecretariaGeneral = id === '1' || (convocatoria.titulo && convocatoria.titulo.toLowerCase().includes('secretaria'));

  if (esSecretariaGeneral) {
    return (
      <div className="convocatoria-detalle convocatoria-detalle-simple">
        <article className="section convocatoria-simple-section">
          <div className="container">
            <Link to="/convocatorias" className="back-link">← Volver a convocatorias</Link>
            <div className="convocatoria-simple-layout">
              <div className="convocatoria-simple-content">
              <header className="convocatoria-simple-header">
                <p className="convocatoria-simple-entity">Diócesis de Ipiales</p>
                <p className="convocatoria-simple-tipo">Convocatoria Laboral</p>
                <p className="convocatoria-simple-cargo-label">Cargo</p>
                <h1 className="convocatoria-simple-title">Secretaria General – Curia Episcopal</h1>
              </header>
              <p className="convocatoria-simple-cierre">Cierre: 15 de febrero de 2026</p>
              <p className="convocatoria-simple-texto">{TEXTO_INVITACION_SECRETARIA}</p>
              <div className="convocatoria-simple-actions">
                <a
                  href={PDF_SECRETARIA_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="convocatoria-simple-btn-descargar"
                >
                  <FaFilePdf /> Postúlate aquí
                </a>
              </div>
              </div>
              <aside className="convocatoria-simple-aside">
                <img src="/images/conv.jpg" alt="Convocatoria Laboral - Secretaria General" className="convocatoria-simple-imagen" />
              </aside>
            </div>
          </div>
        </article>
      </div>
    );
  }

  return (
    <div className="convocatoria-detalle">
      <article className="section">
        <div className="container">
          <Link to="/convocatorias" className="back-link">← Volver a convocatorias</Link>

          {convocatoria.imagen_url && (
            <NoticiaImage
              src={convocatoria.imagen_url}
              alt={convocatoria.titulo}
              className="convocatoria-detail-image"
            />
          )}

          <div className="convocatoria-header">
            {convocatoriaCerrada(convocatoria) && (
              <span className="convocatoria-cerrada-badge">Cerrada</span>
            )}
            {convocatoria.destacada && !convocatoriaCerrada(convocatoria) && (
              <span className="convocatoria-destacada-badge"><FaStar /> Destacada</span>
            )}
            <h1>{convocatoria.titulo}</h1>
            <div className="convocatoria-fechas-detalle">
              <div className="fecha-item">
                <strong>Fecha de inicio:</strong>
                <span>{formatarFechaLocal(convocatoria.fecha_inicio)}</span>
              </div>
              <div className="fecha-item">
                <strong>Fecha de cierre:</strong>
                <span>{formatarFechaLocal(convocatoria.fecha_fin)}</span>
              </div>
              {(convocatoria.actualizado_en || convocatoria.fecha_actualizacion) && (
                <div className="fecha-item">
                  <strong>Última actualización:</strong>
                  <span>{new Date(convocatoria.actualizado_en || convocatoria.fecha_actualizacion).toLocaleDateString('es-CO', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}</span>
                </div>
              )}
            </div>
          </div>

          <div className="convocatoria-body">
            <div dangerouslySetInnerHTML={{ __html: convocatoria.descripcion }} />
          </div>

          <div className="convocatoria-postulacion-pdf">
            <p className="convocatoria-postulacion-aviso">
              La postulación se realiza mediante el formulario que se encuentra dentro del PDF. Descargue el documento, lea los requisitos y, si los cumple, complete el formulario incluido en el PDF para postularse.
            </p>
            <a
              href="/api/pdf/terminos"
              target="_blank"
              rel="noopener noreferrer"
              className="convocatoria-btn-pdf"
            >
              <FaFilePdf /> Postúlate aquí
            </a>
          </div>
        </div>
      </article>
    </div>
  );
};

export default ConvocatoriaDetalle;



